/* ==========================================================================
   SmartHome-Energy — Footer: Spalten-Accordion auf Mobile
   Desktop (>=620px): Panels immer offen, Trigger inaktiv.
   Mobile: echtes Accordion mit aria-expanded + max-height Animation.

   Ausserdem (ab 09/2026): Der Mini-Warenkorb im Header darf nicht direkt zur
   Kasse verlinken — siehe zweiter IIFE am Dateiende.
   ========================================================================== */
(function () {
  "use strict";
  var MQ = "(min-width: 620px)";

  function panelOf(btn) {
    var id = btn.getAttribute("aria-controls");
    return id ? document.getElementById(id) : null;
  }

  function setOpen(btn, open) {
    var panel = panelOf(btn);
    btn.setAttribute("aria-expanded", String(open));
    if (!panel) return;
    panel.style.maxHeight = open ? panel.scrollHeight + "px" : null;
  }

  function applyMode(group) {
    var desktop = window.matchMedia && window.matchMedia(MQ).matches;
    group.querySelectorAll(".she-footer__toggle").forEach(function (btn) {
      var panel = panelOf(btn);
      if (desktop) {
        btn.setAttribute("aria-expanded", "true");
        btn.setAttribute("aria-disabled", "true");
        btn.setAttribute("tabindex", "-1");
        if (panel) panel.style.maxHeight = null;
      } else {
        btn.removeAttribute("aria-disabled");
        btn.removeAttribute("tabindex");
        if (btn.getAttribute("aria-expanded") !== "true") {
          btn.setAttribute("aria-expanded", "false");
          if (panel) panel.style.maxHeight = null;
        } else if (panel) {
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      }
    });
  }

  function initFooterAccordions() {
    var groups = document.querySelectorAll("[data-she-footer-acc]");
    groups.forEach(function (group) {
      if (group.__sheFooterAccBound) return;
      group.__sheFooterAccBound = true;

      group.querySelectorAll(".she-footer__toggle").forEach(function (btn) {
        btn.addEventListener("click", function () {
          if (window.matchMedia && window.matchMedia(MQ).matches) return;
          setOpen(btn, btn.getAttribute("aria-expanded") !== "true");
        });
      });

      applyMode(group);

      var t;
      window.addEventListener("resize", function () {
        clearTimeout(t);
        t = setTimeout(function () { applyMode(group); }, 150);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFooterAccordions);
  } else {
    initFooterAccordions();
  }
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", initFooterAccordions);
  }
})();

/* ==========================================================================
   Mini-Warenkorb im Header: kein Direktlink zur Kasse (EU-Gewaehrleistung)

   Der gesetzlich vorgeschriebene Hinweis "Gesetzliche Gewaehrleistung"
   (Pflicht ab 27.09.2026, DVO (EU) 2025/1960) steht vollstaendig auf der
   Warenkorbseite. Der Mini-Warenkorb (.shx-cartd aus sections/she-header.liquid)
   hatte einen Button "Zur Kasse" direkt auf /cart/checkout und haette den
   Hinweis damit uebersprungen. Hier wird daraus ein einziger Button
   "Zum Warenkorb". Ohne JavaScript blendet she-a11y-fix.css den Kassen-Button
   aus. Dauerhafte Loesung: Zeile mit "Zur Kasse" in sections/she-header.liquid
   loeschen — dieser Block ist dann wirkungslos.
   ========================================================================== */
(function () {
  "use strict";

  function fixMiniCart() {
    document.querySelectorAll('.shx-cartd__foot a[href*="/checkout"]').forEach(function (checkoutLink) {
      var foot = checkoutLink.parentNode;
      var cartLink = foot ? foot.querySelector('a[href$="/cart"]') : null;
      if (cartLink) {
        cartLink.classList.remove("shx-btn--ghost");
        cartLink.classList.add("shx-btn--primary");
        checkoutLink.parentNode.removeChild(checkoutLink);
      } else {
        checkoutLink.setAttribute("href", "/cart");
        checkoutLink.textContent = "Zum Warenkorb";
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", fixMiniCart);
  } else {
    fixMiniCart();
  }
  document.addEventListener("shopify:section:load", fixMiniCart);
})();